<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="60%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    @new-confirm-and-add-other-action="createEntryAndAddOther"
    :saveAndAddOtherButtonEnabled="true"    
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :packaging="packaging"
        :extraData="extraData"
        :itemLots="itemLots"
        :movementItem="movementItem"
        :storageAdjustment="storageAdjustment"
        :modelNameSingular="modelNameSingular"
        :isNewItemInStorage="isNewItemInStorage"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';

import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    movementItem: Object,
    modelNameSingular: String,
    packaging: Object,
    itemLots: {
      type: Array,
      default: new Array(),
    },
    storageAdjustment: Object,
    isNewItemInStorage: {
      type: Boolean, 
      default: false,
    },
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: NEW_PURCHASE_ITEM_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.dummyEntryPurchaseItemLot;
          // this.entry.validations = response.data.accountContext.dummyEntryPurchaseItemLot.validations;         
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    createEntry: function() {
      // console.log("create entry 1", this.entry);
      if(this.entry.name){
        console.log("");
      }else{
        this.entry.name = this.entry.lotNumber+" F:"+this.entry.manufacturingDate+" V:"+this.entry.dueDate;
      }
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    createEntryAndAddOther: function() {
      if (this.createEntry()){
        this.loadServerEntry();
        this.$refs.baseNew.newDialog = true;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const NEW_PURCHASE_ITEM_QUERY = gql `
  {
    accountContext {
      dummyEntryPurchaseItemLot {
        id
        quantity
        packagingQuantity
        name
        lotNumber
        isNewLot
        manufacturingDate
        dueDate
        manufacturingLotId        
        validations
      }
      allStorages {
        id
        name
        location
      }
    }
  }
`;

</script>

<style scoped></style>
